import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "../../style/contactPage/contactpage.scss";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_SEARCH_API;

function ContactCareer() {
  const [career, setCareer] = useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const response = await axios.get(`${API_BASE_URL}/pages/110`);

        // Debug logs to see the structure of your data
        console.log("API Response Data:", response.data);

        const data = response.data;

        console.log("DEBUG ACF:", data?.acf);
        console.log("DEBUG CAREER:", data?.acf?.career);

        const careerData = Array.isArray(data?.acf?.career)
          ? data.acf.career
          : [];

        setCareer(careerData);
      } catch (error) {
        console.error("Error fetching data", error);
        setError(error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const navigate = useNavigate();

  return (
    <div>
      <Container className="py-5">
        <h2 className="mb-4 fw-bold text-center">Career Openings</h2>

        {isLoading && <p>Loading...</p>}
        {!isLoading && career?.length === 0 && <p>No job openings found.</p>}
        {error && <p>Error fetching job data. Please try again later.</p>}

        {career?.map((job, index) => (
          <Row key={index} className="align-items-center py-3 border-bottom">
            <Col md={8}>
              <h5 className="fw-semibold mb-1">{job.career_title}</h5>
              <div>{job.career_desc}</div>
              <div>{job.career_date}</div>
            </Col>
            <Col md={4} className="text-end">
              <div className="mb-2">📍 {job.career_location}</div>
              <Button
                onClick={() => navigate(`/job-details/${index}`)} // Navigates to /job-details/:id
                variant="outline-dark"
                size="sm"
              >
                {job.career_button || "View Details"}
              </Button>
            </Col>
          </Row>
        ))}
      </Container>
    </div>
  );
}

export default ContactCareer;
